import { motion } from "framer-motion";
import { Heart, TrendingUp } from "lucide-react";

const FUNNEL = [
  { label: "Followers", value: "48,200", w: "100%", op: 0.22 },
  { label: "Profile visits", value: "9,640", w: "72%", op: 0.42 },
  { label: "Storefront clicks", value: "2,410", w: "48%", op: 0.68 },
  { label: "Paying customers", value: "486", w: "30%", op: 1 },
];

const IMG_MAIN =
  "https://images.pexels.com/photos/6333757/pexels-photo-6333757.jpeg?auto=compress&cs=tinysrgb&w=1100";
const IMG_PHONE =
  "https://images.unsplash.com/photo-1611926653458-09294b3142bf?auto=format&fit=crop&w=700&q=80";

export const MzGrowth = () => (
  <section className="py-20 sm:py-28 bg-[#FAFAFA] border-y border-neutral-100">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
          >
            <p className="mz-eyebrow mb-3">Social media, monetized</p>
            <h2 className="mz-h text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
              Your audience is already there.{" "}
              <span className="mz-gold-text">Give them somewhere to buy.</span>
            </h2>
            <p className="mt-5 text-[15px] text-neutral-500 leading-relaxed max-w-md">
              Every post, reel and story points to one link. The Hub turns that
              attention into orders, automatically.
            </p>
          </motion.div>

          <div className="mt-10 space-y-3" data-testid="growth-funnel-visual">
            {FUNNEL.map((f, i) => (
              <div key={f.label}>
                <motion.div
                  initial={{ width: 0, opacity: 0 }}
                  whileInView={{ width: f.w, opacity: 1 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.9, delay: i * 0.14, ease: "easeOut" }}
                  className="relative h-12 rounded-full flex items-center justify-between px-5 min-w-[210px]"
                  style={{
                    background: `linear-gradient(110deg, rgba(191,149,63,${f.op}), rgba(252,246,186,${f.op}), rgba(179,135,40,${f.op}))`,
                    border: "1px solid rgba(212,175,55,0.25)",
                  }}
                >
                  <span className="text-[12px] font-semibold text-[#4a3a10]">{f.label}</span>
                  <span className="mz-h text-[13px] font-bold text-[#1a1206]">{f.value}</span>
                </motion.div>
              </div>
            ))}
            <p className="pt-2 text-[10.5px] tracking-[0.14em] uppercase text-neutral-400" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
              Live from a GoldKey storefront · last 30 days
            </p>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8 }}
          className="relative h-[440px] sm:h-[500px]"
          data-testid="growth-collage"
        >
          <div className="absolute right-0 top-0 w-[80%] h-[74%] rounded-3xl overflow-hidden shadow-[0_30px_70px_rgba(10,10,10,0.16)]">
            <img src={IMG_MAIN} alt="A creator filming content with a ring light for social media." className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div className="absolute left-0 bottom-0 w-[52%] h-[46%] rounded-2xl overflow-hidden border-4 border-white shadow-[0_24px_60px_rgba(10,10,10,0.18)]">
            <img src={IMG_PHONE} alt="Social media apps on a phone driving traffic to a storefront." className="w-full h-full object-cover" loading="lazy" />
          </div>
          <div className="absolute top-6 left-[4%] z-10 mz-float">
            <div className="flex items-center gap-2 bg-white rounded-full shadow-[0_12px_32px_rgba(10,10,10,0.12)] border border-neutral-100 px-4 py-2.5">
              <Heart size={13} className="text-[#AA771C]" strokeWidth={2.2} fill="#D4AF37" />
              <span className="text-[11.5px] font-bold text-neutral-800">12.4k likes</span>
            </div>
          </div>
          <div className="absolute bottom-[38%] right-[6%] z-10 mz-float-delay">
            <div className="flex items-center gap-2 bg-white rounded-full shadow-[0_12px_32px_rgba(10,10,10,0.12)] border border-neutral-100 px-4 py-2.5">
              <TrendingUp size={13} className="text-[#AA771C]" strokeWidth={2.4} />
              <span className="text-[11.5px] font-bold text-neutral-800">+38% revenue this month</span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
